import { render, staticRenderFns } from "./FreshdeskCustomerTicketAdd.vue?vue&type=template&id=6d1a3159&scoped=true&"
import script from "./FreshdeskCustomerTicketAdd.vue?vue&type=script&lang=js&"
export * from "./FreshdeskCustomerTicketAdd.vue?vue&type=script&lang=js&"
import style0 from "./FreshdeskCustomerTicketAdd.vue?vue&type=style&index=0&id=6d1a3159&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a3159",
  null
  
)

export default component.exports